import { BASE64_MATCHER } from './regex';

export const isBase64String = (str?: string): boolean => {
  if (!str) return false;

  return BASE64_MATCHER.test(str);
};
